import { z } from "zod";
export const MARKETS = ["fi", "us"];
export const marketSchema = z.enum(MARKETS);
export const DEFAULT_MARKET = "fi";
